<template>
  <svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.8346 3.75L4.8763 9.70833L2.16797 7" stroke="#8D8FA4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>